module.exports = __webpack_public_path__ + "static/media/case-realestate.28037f64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-realestate.jpg
// module id = 87
// module chunks = 3